module.exports = __webpack_public_path__ + "img/search-interface-symbol.898222d4.svg";